import { ReactElement } from 'react';

interface WarnCircleProps {
  size?: number;
  color?: string;
}

export const WarnCircle = ({ color, size }: WarnCircleProps): ReactElement => (
  <svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.75521 5.33268L8.75521 7.99935M8.75521 10.666L8.74854 10.666M2.08854 7.99935C2.08854 4.31745 5.07331 1.33268 8.75521 1.33268C12.4371 1.33268 15.4219 4.31745 15.4219 7.99935C15.4219 11.6812 12.4371 14.666 8.75521 14.666C5.07331 14.666 2.08854 11.6812 2.08854 7.99935Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
